import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import ListContainer from "../../atoms/ListContainer";
import NavDropdownMenu from "../../molecules/NavDropdownMenu";

const MainNavLinks = ({ mainNavItems }) => {
  const linkNavItems = mainNavItems
    ? mainNavItems.map((item) => {
        if (item.links.length > 1) {
          return (
            <NavDropdownMenu
              key={item.slug}
              menuLink={item}
              className={`${item.slug}-dropdown-menu`}
              id={`${item.slug}-dropdown`}
            />
          );
        } else {
          return (
            <li key={item.slug} className="main-nav-links__item">
              <NavLink
                to={`/${item.links[0].path}`}
                exact={item.links[0].path === ""} // ensure Home page does not stay permanently active
                aria-label={`Visit ${item.name}`}
              >
                {item.name}
              </NavLink>
            </li>
          );
        }
      })
    : null;

  return (
    <div className="main-nav-links__container">
      <ListContainer>{linkNavItems}</ListContainer>
    </div>
  );
};

MainNavLinks.propTypes = {
  mainNavItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({ name: PropTypes.string, path: PropTypes.string, exact: PropTypes.bool })
      ),
    })
  ),
};

export default MainNavLinks;
